// extracted by mini-css-extract-plugin
module.exports = {"groupsProposalList":"ProposalList_groupsProposalList__o8oIW","proposal":"ProposalList_proposal__A71j5","icon":"ProposalList_icon__pwbc1"};